import { CopyButton } from '@shared/ui/copy-button/copy-button'
import s from './link-reverral-card.module.scss'
import { getCDNPath } from '@utils/lib/getCDNpath'


const baseReferralUrl = 'https://app.sozvuchno.ru/sign-up/'

export const LinkReferralCard = ({referral_token}) => {

    const referralLink = baseReferralUrl + referral_token

    return (
        <div className={s.container}>
            <div className={s.avatarsContainer}>
                <div className={s.avatar}><img src={getCDNPath("images/avatars/avatar-sax.webp")} alt=''></img></div>
                <div className={s.avatar}><img src={getCDNPath("images/avatars/avatar-cello.webp")} alt=''></img></div>
                <div className={s.avatar}><img src={getCDNPath("images/avatars/avatar-violin-1.webp")} alt=''></img></div>
                <div className={s.avatar}><img src={getCDNPath("images/avatars/avatar-flute.webp")} alt=''></img></div>
                <div className={s.avatar}><img src={getCDNPath("images/avatars/avatar-violin-2.webp")} alt=''></img></div>
            </div>
            <div className={s.info}>
                <h1>Ваша персональная ссылка</h1>
                <p>Приглашай новых преподавателей по своей ссылке и получай сниженную комиссию</p>
            </div> 
            <CopyButton
                text={referralLink}
                label={referralLink}
                copiedLabel='Скопировано!'
                theme='secondary'
                className={s.button}
            />
        </div>
    )
}